// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".banner{position:relative}.banner__inner-banner{max-height:390px;overflow:hidden;object-position:top;object-fit:scale-down}\n", ""]);
// Exports
module.exports = exports;
